import { render, staticRenderFns } from "./ListContratos.vue?vue&type=template&id=40fdc14a&"
import script from "./ListContratos.vue?vue&type=script&lang=js&"
export * from "./ListContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports